<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><a id="page_iv">© 2017 Johns Hopkins University Press</a></p><a id="page_iv">
<p class="copy">All rights reserved. Published 2017</p>
<p class="copy">Printed in the United States of America on acid-free paper</p>
<p class="copy">2 4 6 8 9 7 5 3 1</p>
<p class="copyt">Johns Hopkins University Press</p>
<p class="copy">2715 North Charles Street</p>
<p class="copy">Baltimore, Maryland 21218-4363</p>
</a><p class="copy"><a id="page_iv"></a><a class="nounder" href="http://www.press.jhu.edu" target="_blank">www.press.jhu.edu</a></p>
<p class="copyt">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyt">Names: Merritt, Jane T., author.</p>
<p class="copy">Title: The trouble with tea : the politics of consumption in the eighteenth-century global economy / Jane T. Merritt.</p>
<p class="copy">Description: Baltimore : Johns Hopkins University Press, 2017. | Series: Studies in early American economy and society from the Library Company of Philadelphia | Includes bibliographical references and index.</p>
<p class="copy">Identifiers: LCCN 2016012792| ISBN 9781421421520 (hardcover : alk. paper) |</p>
<p class="copy">ISBN 9781421421544 (pbk. : alk. paper) | ISBN 9781421421544 (electronic) |</p>
<p class="copy">ISBN 1421421526 (hardcover : alk. paper) | ISBN 1421421534 (pbk. : alk. paper) | ISBN 1421421542 (electronic)</p>
<p class="copy">Subjects: LCSH: Tea trade—Political aspects—History—18th century | Great Britain—Commerce—History. | United States—Commerce—History. | United States—Foreign economic relations. | Great Britain—Foreign economic relations. | United States—Economic conditions—To 1865.</p>
<p class="copy">Classification: LCC HD9198.A2 M47 2017 | DDC 339.4/8663940941—dc23</p>
<p class="copy">LC record available at <a class="nounder" href="https://lccn.loc.gov/2016012792" target="_blank">https://lccn.loc.gov/2016012792</a></p>
<p class="copyt">A catalog record for this book is available from the British Library.</p>
<p class="copyt"><em>Special discounts are available for bulk purchases of this book. For more information, please contact Special Sales at 410-516-6936 or specialsales@press.jhu.edu.</em></p>
<p class="copyt">Johns Hopkins University Press uses environmentally friendly book materials, including recycled text paper that is composed of at least 30 percent post-consumer waste, whenever possible.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?7e333a10